import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { LangContext } from '../LangContext';
import { useTranslation } from '../useTranslation';

const Header = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  const { t } = useTranslation();
  const { lang, setLang } = useContext(LangContext);
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('/');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLinkClick = (path) => {
    setActiveLink(path.toLowerCase());
    setMobileMenuOpen(false);
    scrollToTop();
  };

  useEffect(() => {
    setActiveLink(location.pathname.toLowerCase());
  }, [location.pathname]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [mobileMenuOpen]);

  return (
    <>
      <div id="topbar" className={`d-flex align-items-center fixed-top ${scrolled ? 'topbar-scrolled' : ''}`}>
        <div className="container d-flex justify-content-center justify-content-md-between">
          <div className="contact-info d-flex align-items-center">
            <i className="bi bi-phone d-flex align-items-center"><span>+216 98 370 055</span></i>
            <i className="bi bi-clock d-flex align-items-center ms-4"><span> Mon-Fri: 11AM - 5PM</span></i>
          </div>
          <div className="languages d-none d-md-flex align-items-center">
            <ul className="lang-switcher" style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', gap: '15px' }}>
              <li onClick={() => setLang('en')} className={lang === 'en' ? 'active' : ''}>En</li>
              <li onClick={() => setLang('fr')} className={lang === 'fr' ? 'active' : ''}>Fr</li>
            </ul>
          </div>
        </div>
      </div>

      <header id="header" className={`d-flex align-items-center fixed-top ${scrolled ? 'header-scrolled' : ''}`}>
        <div className="container-fluid container-xl d-flex align-items-center justify-content-lg-between">
          
          <h1 className="logo me-auto me-lg-0">
            <Link to="/" onClick={() => handleLinkClick('/')}>
              <img src="assets/img/logo.png" alt="" className="img-fluid"/>
            </Link>
          </h1>

          <nav id="navbar" className="navbar order-last order-lg-0 d-none d-lg-block">
            <ul className="menu" style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              gap: '30px',
              margin: 0,
              padding: 0
            }}>
              <li style={{ listStyle: 'none' }}>
                <NavLink 
                  className="nav-link scrollto" 
                  to="/" 
                  exact 
                  onClick={() => handleLinkClick('/')}
                  style={({ isActive }) => ({ 
                    color: isActive ? '#cba25d' : 'inherit',
                    textDecoration: 'none'
                  })}
                >
                  {t('home')}
                </NavLink>
              </li>
              <li style={{ listStyle: 'none' }}>
                <NavLink 
                  className="nav-link scrollto" 
                  to="/apropos" 
                  onClick={() => handleLinkClick('/apropos')}
                  style={({ isActive }) => ({ 
                    color: isActive ? '#cba25d' : 'inherit',
                    textDecoration: 'none'
                  })}
                >
                  {t('about')}
                </NavLink>
              </li>
              <li style={{ listStyle: 'none' }}>
                <NavLink 
                  className="nav-link scrollto" 
                  to="/boutique" 
                  onClick={() => handleLinkClick('/boutique')}
                  style={({ isActive }) => ({ 
                    color: isActive ? '#cba25d' : 'inherit',
                    textDecoration: 'none'
                  })}
                >
                  {t('boutique')}
                </NavLink>
              </li>
              <li style={{ listStyle: 'none' }}>
                <NavLink 
                  className="nav-link scrollto" 
                  to="/galerie" 
                  onClick={() => handleLinkClick('/galerie')}
                  style={({ isActive }) => ({ 
                    color: isActive ? '#cba25d' : 'inherit',
                    textDecoration: 'none'
                  })}
                >
                  {t('Gallery')}
                </NavLink>
              </li>
              <li style={{ listStyle: 'none' }}>
                <NavLink 
                  className="nav-link scrollto" 
                  to="/contact" 
                  onClick={() => handleLinkClick('/contact')}
                  style={({ isActive }) => ({ 
                    color: isActive ? '#cba25d' : 'inherit',
                    textDecoration: 'none'
                  })}
                >
                  {t('Contact')}
                </NavLink>
              </li>
            </ul>
          </nav>

          <NavLink 
            className="book-a-table-btn scrollto d-none d-lg-flex" 
            to="https://domaine.numidia.pro/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleLinkClick('/')}
            style={{
              marginLeft: 'auto'
            }}
          >
            <i className="bi bi-arrow-right"></i> &nbsp; Domaine Numidya
          </NavLink>

          <div className="d-block d-lg-none" style={{ marginLeft: 'auto' }}>
            <i 
              className={`bi mobile-nav-toggle ${mobileMenuOpen ? 'bi-x' : 'bi-list'}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              style={{
                fontSize: '24px',
                cursor: 'pointer',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '40px',
                width: '40px'
              }}
            ></i>
          </div>
        </div>
      </header>

      {mobileMenuOpen && (
        <div 
          className="mobile-menu-overlay"
          onClick={() => setMobileMenuOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999
          }}
        ></div>
      )}

      <div 
        className={`mobile-nav ${mobileMenuOpen ? 'mobile-nav-open' : ''}`}
        style={{
          position: 'fixed',
          top: 0,
          right: mobileMenuOpen ? 0 : '-320px',
          width: '300px',
          height: '100%',
          backgroundColor: 'white',
          zIndex: 1000,
          transition: 'right 0.3s ease',
          padding: '80px 20px 20px',
          boxShadow: '-5px 0 15px rgba(0,0,0,0.1)',
          overflowY: 'auto'
        }}
      >
        <div style={{
  position: 'absolute',
  top: '20px',
  left: '20px',
  right: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: '15px',
  borderBottom: '1px solid #eee',
  marginBottom: '15px'
}}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  }}>
    <span 
      onClick={() => {
        setLang('en');
        setMobileMenuOpen(false);
      }} 
      style={{
        cursor: 'pointer',
        fontWeight: lang === 'en' ? 'bold' : 'normal',
        color: lang === 'en' ? '#cba25d' : '#333',
        fontSize: '14px',
        padding: '6px 10px',
        borderRadius: '4px',
        backgroundColor: lang === 'en' ? '#f8f9fa' : 'transparent',
        transition: 'all 0.3s ease'
      }}
    >
      EN
    </span>
    <span 
      onClick={() => {
        setLang('fr');
        setMobileMenuOpen(false);
      }} 
      style={{
        cursor: 'pointer',
        fontWeight: lang === 'fr' ? 'bold' : 'normal',
        color: lang === 'fr' ? '#cba25d' : '#333',
        fontSize: '14px',
        padding: '6px 10px',
        borderRadius: '4px',
        backgroundColor: lang === 'fr' ? '#f8f9fa' : 'transparent',
        transition: 'all 0.3s ease'
      }}
    >
      FR
    </span>
  </div>

  <div 
    className="mobile-close-btn"
    onClick={() => setMobileMenuOpen(false)}
    style={{
      fontSize: '24px',
      cursor: 'pointer',
      color: '#333',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    ✕
  </div>
</div>
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: '60px 0 0 0'
        }}>
          <li style={{ marginBottom: '15px' }}>
            <NavLink 
              className="nav-link" 
              to="/" 
              exact 
              onClick={() => handleLinkClick('/')}
              style={({ isActive }) => ({ 
                textDecoration: 'none',
                display: 'block',
                padding: '12px 15px',
                color: isActive ? '#cba25d' : '#333',
                fontSize: '16px',
                borderBottom: '1px solid #eee',
                fontWeight: isActive ? 'bold' : 'normal'
              })}
            >
              {t('home')}
            </NavLink>
          </li>
          
          <li style={{ marginBottom: '15px' }}>
            <NavLink 
              className="nav-link" 
              to="/apropos" 
              onClick={() => handleLinkClick('/apropos')}
              style={({ isActive }) => ({ 
                textDecoration: 'none',
                display: 'block',
                padding: '12px 15px',
                color: isActive ? '#cba25d' : '#333',
                fontSize: '16px',
                borderBottom: '1px solid #eee',
                fontWeight: isActive ? 'bold' : 'normal'
              })}
            >
              {t('about')}
            </NavLink>
          </li>
          
          <li style={{ marginBottom: '15px' }}>
            <NavLink 
              className="nav-link" 
              to="/boutique" 
              onClick={() => handleLinkClick('/boutique')}
              style={({ isActive }) => ({ 
                textDecoration: 'none',
                display: 'block',
                padding: '12px 15px',
                color: isActive ? '#cba25d' : '#333',
                fontSize: '16px',
                borderBottom: '1px solid #eee',
                fontWeight: isActive ? 'bold' : 'normal'
              })}
            >
              {t('boutique')}
            </NavLink>
          </li>
          
          <li style={{ marginBottom: '15px' }}>
            <NavLink 
              className="nav-link" 
              to="/galerie" 
              onClick={() => handleLinkClick('/galerie')}
              style={({ isActive }) => ({ 
                textDecoration: 'none',
                display: 'block',
                padding: '12px 15px',
                color: isActive ? '#cba25d' : '#333',
                fontSize: '16px',
                borderBottom: '1px solid #eee',
                fontWeight: isActive ? 'bold' : 'normal'
              })}
            >
              {t('Gallery')}
            </NavLink>
          </li>
          
          <li style={{ marginBottom: '15px' }}>
            <NavLink 
              className="nav-link" 
              to="/contact" 
              onClick={() => handleLinkClick('/contact')}
              style={({ isActive }) => ({ 
                textDecoration: 'none',
                display: 'block',
                padding: '12px 15px',
                color: isActive ? '#cba25d' : '#333',
                fontSize: '16px',
                borderBottom: '1px solid #eee',
                fontWeight: isActive ? 'bold' : 'normal'
              })}
            >
              {t('Contact')}
            </NavLink>
          </li>

          {/* Bouton Domaine Numidya dans le menu mobile */}
          <li style={{ marginTop: '30px', padding: '15px', borderTop: '1px solid #eee' }}>
            <NavLink 
              className="book-a-table-btn-mobile"
              to="https://domaine.numidia.pro/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleLinkClick('/')}
              style={{
                display: 'block',
                textAlign: 'center',
                padding: '12px 20px',
                backgroundColor: '#cba25d',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '16px'
              }}
            >
              <i className="bi bi-arrow-right"></i> &nbsp; Domaine Numidya
            </NavLink>
          </li>
        </ul>
      </div>

      <style jsx>{`
        /* Menu Mobile */
        .mobile-nav-open {
          right: 0 !important;
        }

        .mobile-menu-overlay {
          display: none;
        }

        @media (min-width: 992px) {
          .mobile-nav-toggle {
            display: none !important;
          }
          
          .mobile-nav {
            display: none !important;
          }
          
          .mobile-menu-overlay {
            display: none !important;
          }
        }

        @media (max-width: 991px) {
          .mobile-menu-overlay {
            display: block;
          }
          
          .navbar.d-none.d-lg-block {
            display: none !important;
          }
          
          .book-a-table-btn {
            display: none !important;
          }

          .mobile-nav-toggle {
            display: flex !important;
          }
        }

        #header {
          height: 80px;
        }

        .navbar {
          display: flex;
          align-items: center;
        }
      `}</style>
    </>
  );
};

export default Header;